export const USE_LOCKOUT_POLICY_SET = 'common/systemSettings/USE_LOCKOUT_POLICY_SET'
export const LOCKOUT_DURATION_SET = 'common/systemSettings/LOCKOUT_DURATION_SET'
export const LOCKOUT_THRESHOLD_SET = 'common/systemSettings/LOCKOUT_THRESHOLD_SET'
export const LOCKOUT_COUNTER_SET = 'common/systemSettings/LOCKOUT_COUNTER_SET'
export const LOCKOUT_UNLOCK_ALL_STATUS_SET = 'common/systemSettings/LOCKOUT_UNLOCK_ALL_STATUS_SET'



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/actionTypes.js